import { render, staticRenderFns } from "./PracticeSumupDetailTotal.vue?vue&type=template&id=09ed58b3&scoped=true&"
import script from "./PracticeSumupDetailTotal.vue?vue&type=script&lang=ts&"
export * from "./PracticeSumupDetailTotal.vue?vue&type=script&lang=ts&"
import style0 from "./PracticeSumupDetailTotal.vue?vue&type=style&index=0&id=09ed58b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ed58b3",
  null
  
)

export default component.exports